import { z } from 'zod';

export const strategicInsightResponseSchema = z.object({
  turmaId: z.number(),
  nomeTurma: z.string().optional(),
  elegivel: z.boolean().optional(),
  motivoInelegibilidade: z.string().optional(),
  foco: z.string().optional(),
  analise: z.string().optional(),
  direcaoEstrategica: z.string().optional(),
});

export type StrategicInsightResponse = z.infer<typeof strategicInsightResponseSchema>;
